import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Polyfills that are currently not configured via babel
import 'whatwg-fetch'
import 'document-register-element/build/document-register-element'
import 'intl'

import 'mutationobserver-shim'
import Vue from 'vue'
import '@/plugins/bootstrap-vue'
import '@/mixins/import'
import { register as registerCustomElements } from '@/helper/customElementsHelper'
import * as Store from '@/store'
import vueCustomElement from 'vue-custom-element'
import { createProvider } from '@/apollo'

import DynSlot from '@/components/generic/DynSlot'
import Tooltip from '@/components/generic/Tooltip'

import Config from '../config/fyve'
import { globalStoreConfig } from '@/store/config'
import { storeConfig } from '@/store/config/fyve'

import CurrentMsisdn from '@/components/process/generic/Customer/Msisdn/CurrentMsisdn'
import LoginComponent from '@/components/process/generic/Authentication/Login/LoginComponent'
import ProductInformationItemVersions
  from '@/components/process/generic/ProductInformationSheet/ProductInformationItemVersions'
import CurrentTariff from './components/process/generic/Tariff/generic/CurrentTariff/CurrentTariff'
import TeaserText from '@/components/generic/TeaserText'
import ConsumptionItemProgressWithDescription from '@/components/process/generic/Consumption/ConsumptionItemProgressWithDescription'

import FriendNotification from './components/process/generic/Notification/FriendNotification'
import FriendNotificationWrapper from '@/components/process/generic/Notification/FriendNotificationWrapper'
import ConsumptionInfoPopoverWithDescription
  from '@/components/process/generic/Consumption/ConsumptionInfoPopoverWithDescription'
import AccordionWrapper from '@/components/process/generic/Accordion/fyve/AccordionWrapper'
import ForgotPasswordWrapper from '@/components/process/generic/Password/ForgotPassword/ForgotPasswordWrapper'
import ResetPasswordConfirmationWrapper from '@/components/process/generic/Password/ResetPassword/fyve/ResetPasswordConfirmationWrapper'

import ChangePaymentWrapper from './components/process/FYVE/Payment/Wrapper/ChangePaymentWrapper'
import PersonalDataWrapper from '@/components/process/generic/PersonalData/fyve/PersonalDataWrapper'
import ConsentWrapper from './components/process/generic/Consent/fyve/ConsentWrapper'
import SendVerificationMail from '@/components/process/generic/PersonalData/fyve/SendVerificationMail'
import BalanceInfo from '@/components/process/generic/Balance/BalanceInfo.vue'
import LogOutLink from './components/process/generic/Authentication/LogOut/LogOutLink'
import DeviceConfigurator from '@/components/process/generic/DeviceConfigurator/DeviceConfigurator'

import SimpleCurrentTariffWrapper from '@/components/process/generic/Tariff/fyve/SimpleCurrentTariffWrapper'
import EmailVerificationModal from '@/components/process/generic/Email/EmailVerification/EmailVerificationModal'
import OrderWrapper from './components/process/FYVE/Order/Wrapper/OrderWrapper'
import EmailConfirmationWrapper from '@/components/process/generic/Email/EmailConfirmation/fyve/EmailConfirmationWrapper'
import MessageView from '@/components/generic/MessageView/MessageList'
import ChangePasswordWrapper from './components/process/generic/Password/ChangePassword/fyve/ChangePasswordWrapper'
import SingleTopUpPaypalWrapper from '@/components/process/generic/TopUp/SingleTopUp/fyve/SingleTopUpPaypalWrapper'
import GDPRDataWrapper from './components/process/generic/GDPRData/GDPRDataWrapper'
import MnpOutStatus from '@/components/process/generic/Mnp/MnpOutStatus/ShowMnpOutStatus'
import SingleTopUpWrapper from '@/components/process/generic/TopUp/SingleTopUp/fyve/SingleTopUpWrapper'
import SingleTopUpVoucherWrapper from '@/components/process/generic/TopUp/SingleTopUp/fyve/SingleTopUpVoucherWrapper'
import ContractId from '@/components/process/generic/Contract/ContractId'
import OppwaCC from '@/components/generic/OppwaCC'
import TariffStatusWrapper from './components/process/generic/Tariff/fyve/TariffStatusWrapper'
import TariffoptionsWrapper from './components/process/generic/Tariff/fyve/TariffoptionsWrapper'
import ChangeEvnWrapper from './components/process/generic/ItemisedBills/fyve/ChangeEvnWrapper'
import CheckSIMCard from './components/process/generic/SimCard/CheckSimCard/View'
import pymHeight from '@/mixins/pymHeight'
import ActivationWrapper from '@/components/process/FYVE/Activation/Wrapper/ActivationWrapper.vue'
import MnpInWrapper from '@/components/process/generic/Mnp/MnpIn/fyve/MnpInWrapper'
import AutoTopUpWrapper from '@/components/process/generic/TopUp/ChangeAutoTopUp/fyve/AutoTopUpWrapper'
import SubstituteSimCardWrapper from '@/components/process/generic/SimCard/SubstituteSimCard/fyve/SubstituteSimCardWrapper'
import EvnWrapper from './components/process/generic/ItemisedBills/fyve/EvnWrapper'
import NewsletterUnsubscribe from './components/process/generic/Newsletter/NewsletterUnsubscribe.vue'
import CancellationWrapper from './components/process/generic/Cancellation/CancellationWrapper'
import ContractSummary from '@/components/process/generic/Tariff/generic/ContractSummary'
import ExternalOrderContractSummary from '@/components/process/generic/ExternalOrderContractSummary/DownloadContractSummary'
import CustomerDocumentListOverview from '@/components/process/generic/CustomerDocumentList/CustomerDocumentListOverview.vue'
import CustomerDocumentBanner from '@/components/process/generic/CustomerDocumentList/CustomerDocumentBanner.vue'

const API_BASE_URL = process.env.VUE_APP_FYVE_API_BASE_URL || process.env.VUE_APP_API_BASE_URL
const GRAPHQL_HTTP = process.env.VUE_APP_FYVE_GRAPHQL_HTTP || process.env.VUE_APP_GRAPHQL_HTTP

const TRIGGER_SESSION_TRANSFER = 'getSessionStorage'
const TRANSFER_KEY = 'sessionStorage'

Vue.use(Config, {
  apiUrl: API_BASE_URL
})

const DEBUG_MODE = sessionStorage.getItem('DEBUG_MODE') === 'true'

Vue.mixin(pymHeight(DEBUG_MODE))

let store

// transfers sessionStorage from one tab to another

function sessionStorageTransfer (event) {
  if (!event) { event = window.event } // ie suq
  if (!event.newValue) return
  // do nothing if no value to work with
  if (event.key === TRIGGER_SESSION_TRANSFER) {
    // another tab asked for the sessionStorage -> send it
    localStorage.setItem(TRANSFER_KEY, JSON.stringify(sessionStorage.getItem('portal-session')))
    // the other tab should now have it, so we're done with it.
    localStorage.removeItem(TRANSFER_KEY) // <- could do short timeout as well.
  } else if (event.key === TRANSFER_KEY) {
    // another tab sent data <- get it
    if (sessionStorage.getItem('portal-session') != null) {
      // other tab was quicker. ignore this one
      return
    }
    const data = JSON.parse(event.newValue)
    sessionStorage.setItem('portal-session', data)
    store = Store.createStore({
      ...globalStoreConfig,
      ...storeConfig
    })
    initializeApplication()
  }
}

// listen for changes to localStorage
if (window.addEventListener) {
  window.addEventListener('storage', sessionStorageTransfer, false)
} else {
  window.attachEvent('onstorage', sessionStorageTransfer)
}
// The opened tab requests the session storage content
// this is performed async
// wann wollen wir abrufen?
//   neuer Tab!
//   1. aktuell keine portal-session
//   2. (window.history = 1)
if (sessionStorage.getItem('portal-session') == null) {
  localStorage.setItem(TRIGGER_SESSION_TRANSFER, 'foobar')
  localStorage.removeItem(TRIGGER_SESSION_TRANSFER, 'foobar')
  // if there is no other tab open, nobody will answer :(
  // so we have to set a timeout to do the stuff ourself :)
  setTimeout(function () {
    if (sessionStorage.getItem('portal-session') == null) {
      initializeStore()
      initializeApplication()
    }
  }, 100)
} else {
  initializeStore()
  initializeApplication()
}
// End transfers sessionStorage from one tab to another

function initializeStore () {
  store = Store.createStore({
    ...globalStoreConfig,
    ...storeConfig
  })
  store.commit('selectBrand', 'fyve')
  store.commit('selectRetailerId', null)
  store.commit('selectType', 'DELIVERY')
  // ggf. hier auf ENVs gehen, wenn nötig -> process.env.FYVE_CLIENT_ID + FYVE_CLIENT_SECRET
  store.commit('selectClient', { id: 'fyve', secret: 'fyve' })
  store.commit('selectBaseUrl', API_BASE_URL)
}

function initializeApplication () {
  const apolloProvider = createProvider(store, {
    autoLogoutMessage: 'Es ist ein technischer Fehler aufgetreten. Sie wurden zur Sicherheit abgemeldet. Bitte melden Sie sich erneut an. Sollten die Probleme bestehen bleiben, so wenden Sie sich an die Hotline.',
    httpEndpoint: GRAPHQL_HTTP,
    restEndpoint: API_BASE_URL
  })

  Vue.component('dyn-slot', DynSlot)

  Vue.config.productionTip = false

  Vue.config.ignoredElements = [
    // Use a `RegExp` to ignore all elements that start with "ion-"
    // 2.5+ only
    // /^ion-/
  ]

  Vue.use(vueCustomElement)
  Vue.component('dyn-slot', DynSlot)
  Vue.component('ProductInformationItem', ProductInformationItemVersions)
  Vue.component('ConsumptionItem', ConsumptionItemProgressWithDescription)
  Vue.component('ConsumptionInfoPopover', ConsumptionInfoPopoverWithDescription)
  Vue.component('FriendNotification', FriendNotification)

  registerCustomElements({
    // generics
    'app-tooltip': Tooltip,
    'app-teaser-text': TeaserText,
    'app-message-view': MessageView,
    'app-current-msisdn': CurrentMsisdn,
    'app-current-tariff': CurrentTariff,
    'app-check-sim-card': CheckSIMCard,
    // app-send-verification-mail has to be registered before app-email-verification-modal
    // because it's used inside the modal.
    'app-send-verification-mail': SendVerificationMail,
    'app-balance-info': BalanceInfo,
    'app-logout': LogOutLink,
    'app-email-verification-modal': EmailVerificationModal,
    // processes
    'app-change-personal-data-wrapper': PersonalDataWrapper,
    'app-change-payment-wrapper': ChangePaymentWrapper,
    'app-consent-wrapper': ConsentWrapper,
    'app-login': LoginComponent,
    'app-reset-password-confirmation-wrapper': ResetPasswordConfirmationWrapper,
    'app-forgot-password-wrapper': ForgotPasswordWrapper,
    'app-device-configurator': DeviceConfigurator,
    'app-simple-current-tariff-wrapper': SimpleCurrentTariffWrapper,
    'app-order-wrapper': OrderWrapper,
    'app-activation-wrapper': ActivationWrapper,
    'app-mnp-in-wrapper': MnpInWrapper,
    'app-email-confirmation-wrapper': EmailConfirmationWrapper,
    'app-change-password-wrapper': ChangePasswordWrapper,
    'app-friend-notification-wrapper': FriendNotificationWrapper,
    'app-single-topup-paypal-wrapper': SingleTopUpPaypalWrapper,
    'app-contract-id': ContractId,
    'app-single-topup-wrapper': SingleTopUpWrapper,
    'app-gdpr-data-wrapper': GDPRDataWrapper,
    'app-mnp-out-status': MnpOutStatus,
    'app-change-evn-wrapper': ChangeEvnWrapper,
    'app-evn-wrapper': EvnWrapper,
    'app-single-top-up-voucher-wrapper': SingleTopUpVoucherWrapper,
    'app-tariff-status-wrapper': TariffStatusWrapper,
    'app-tariffoptions-wrapper': TariffoptionsWrapper,
    'app-newsletter-unsubscribe': NewsletterUnsubscribe,
    // STOP
    // THIS SHOULD BE THE LAST REGISTERED COMPONENT
    // prevents "Unkonwn custom element" error on processes in accordions
    'app-accordion-wrapper': AccordionWrapper,
    'app-oppwa': OppwaCC,
    'app-auto-topup-wrapper': AutoTopUpWrapper,
    'app-substitute-sim-wrapper': SubstituteSimCardWrapper,
    'app-cancellation-wrapper': CancellationWrapper,
    'app-contract-summary': ContractSummary,
    'app-external-order-contract-summary': ExternalOrderContractSummary,
    'app-customer-document-list-overview': CustomerDocumentListOverview,
    'app-customer-document-banner': CustomerDocumentBanner
  }, store, apolloProvider)
}
